import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import SolutionPage from "./pages/SolutionPage";
import RealisationsPage from "./pages/RealisationsPage";
import InvestirPage from "./pages/InvestirPage";
import ContactPage from "./pages/ContactPage";
import ResourcesPage from "./pages/ResourcesPage";
import ArticlePage from "./pages/ArticlePage";
import RendezVousPage from "./pages/RendezVousPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#FAF9F6]" />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

const PublicLayout = () => (
  <>
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

const AppContent = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin routes - no Navbar/Footer */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* Public routes with Navbar/Footer layout */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/solution" element={<SolutionPage />} />
          <Route path="/realisations" element={<RealisationsPage />} />
          <Route path="/investir" element={<InvestirPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/ressources" element={<ResourcesPage />} />
          <Route path="/ressources/:slug" element={<ArticlePage />} />
          <Route path="/rendez-vous" element={<RendezVousPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </div>
  );
}

export default App;
